var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"viewer_content"},[_c('div',{staticStyle:{"all":"initial"},domProps:{"innerHTML":_vm._s(!!_vm.internalValue.terms ? _vm.internalValue.terms : undefined)}},[_vm._v(" "+_vm._s(_vm.internalValue.supplyCompanyName)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }